const SHOW_MODAL_PROMPT = 'client/modalPrompt/SHOW_MODAL_PROMPT';
const HIDE_MODAL_PROMPT = 'client/modalPrompt/HIDE_MODAL_PROMPT';

const initialState = {
  isVisible: false,
  properties: {
    closeOnEscape: true,
    isButton1Default: false,
    isButton2Default: false,
  }
};

function modalPromptReducer(state = initialState, action = {}) {
  switch (action.type) {
    case SHOW_MODAL_PROMPT:
      return {
        ...state,
        isVisible: true,
        properties: action.payload,
      };
    case HIDE_MODAL_PROMPT:
      return {
        ...state,
        isVisible: false,
      };
    default:
      return state;
  }
}

function showModalPrompt(properties) {
  return {
    type: SHOW_MODAL_PROMPT,
    payload: properties,
  };
}

function hideModalPrompt() {
  return {
    type: HIDE_MODAL_PROMPT
  };
}

const actions = {
  showModalPrompt,
  hideModalPrompt,
};

// Convenience utility
export function showSingleButtonAlert(message, args) {
  return showModalPrompt(propsForSingleButtonAlert(message, args));
}

export function propsForSingleButtonAlert(message, args) {
  return {
    message: message,
    messageArguments: args,
    button1text: null,
    isButton2Default: true,
    closeOnEscape: true,
  };
}

export { actions };
export default modalPromptReducer;



// WEBPACK FOOTER //
// ./src/portfolio-shared/state/reducers/modalPromptReducer.js